import React, { Component } from 'react';
import { Row } from 'antd';
import { graphql, compose } from 'react-apollo';
import moment from 'moment-timezone';
import Spinner from '../../spinner/spinner';
import { Route } from 'react-router-dom';
import { getCurrentUserSuccessReports } from './queries/getCurrentUserSuccessReports'
import { MINIMUM_PUBLISHED_PHASE } from './constants'

import SuccessReportList from "./list"
import SuccessReportForm from "./form";

import './successReports.css';

class SuccessReports extends Component {
  successReportList = (props) => {
    return <SuccessReportList {...props} selectedChurch={this.props.selectedChurch}/>
  };

  successReportForm = (props) => {
    return <SuccessReportForm {...props} selectedChurch={this.props.selectedChurch}/>
  };

  successReportDescriptionClass = () => {
    return this.props.data.church.revival.phase === MINIMUM_PUBLISHED_PHASE ? "success-report__item--hidden" : null;
  };

  render() {
    if (this.props.data.loading) {
      return <Spinner />;
    }
    const revivalEndDate = moment.unix(this.props.data.church.revival.endDate).format('MMMM Do');
    return (
      <div>
        <div className="dashboard-layout__placeholder"/>
        <div className="m-24">
          <Row style={{height: 40}}>
            <h2 style={{marginBottom: 10}}>Event Report</h2>
          </Row>
          <Row className={this.successReportDescriptionClass()}>
            <p className="m-b-24">
              Event report will be published and becomes visible to Church members only when the Event is
              completed ({revivalEndDate}). Until then only you will be able to see the text of the Report - so please feel
              free to work on it beforehand.
            </p>
          </Row>
          <Row>
            <Route exact path={`${this.props.match.url}`} render={this.successReportList} />
            <Route exact path={`${this.props.match.url}/edit`} render={this.successReportForm}/>
          </Row>
        </div>
      </div>
    )
  }
}

export default compose(
  graphql(getCurrentUserSuccessReports, {
    options: ({ selectedChurch }) => ({ variables: { id: selectedChurch.id } })
  })
)(SuccessReports);



// WEBPACK FOOTER //
// ./src/components/pages/successReports/successReports.js